export interface FormCheckboxPrimary {
  className?: string
  inputClassName?: string
  name?: string
  id?: string
  ariaDescribedby?: string
  children?: JSX.Element
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  value?: string
  checked?: boolean
  isError?: boolean
}

// TODO: need refectoring for component,
// value for checkbox is string instead of boolean
export function FormCheckboxPrimary({
  className = '',
  name,
  id,
  ariaDescribedby = '',
  children,
  onChange,
  value = 'false',
  inputClassName = '',
  checked,
  isError,
}: FormCheckboxPrimary) {
  return (
    <div className={`${className} flex w-full flex-row gap-3 `}>
      <div className='w-[20px]'>
        <input
          id={id}
          defaultChecked={value === 'true'}
          value={value}
          onChange={onChange}
          aria-describedby={ariaDescribedby}
          name={name}
          type='checkbox'
          checked={checked}
          className={`checked:bg-border-primary relative box-border h-[20px] w-[20px] appearance-none rounded
        border checked:text-mainBody checked:before:absolute checked:before:left-[3px] checked:before:top-[3px]  checked:before:content-[url('/check.svg')] ${
          isError ? '!border-red' : '!border-dark'
        }  ${inputClassName}`}
        />
      </div>
      <div>{children}</div>
    </div>
  )
}

export default FormCheckboxPrimary
